<template>
  <div>
    <collapsible-widget 
      title="WARSTWY UŻYTKOWNIKA"
      :maxHeight="30"
      :expand-widget="$store.getters.userLayersExpanded"
      :accordion="accordion"
      @toggled="onToggled"
      ref="collapsible"
      :default-expanded="$store.getters.userLayersExpanded"
      :selectAllEnabled="userLayersHasItems"
      :onCheckboxChanged="onCheckboxChanged"
      :allSelected.sync="allSelected"
      :indeterminate="indeterminate">
      <composition-layers :layers="userGroupLayers" @set-layer-extent="setLayerExtent"></composition-layers>
    </collapsible-widget>

    <b-modal v-model="showModal" centered title="Dodaj warstwę" size="lg" @ok.prevent="addLayer" ok-title="Dodaj" cancel-title="Anuluj" @hidden="clear">
        <b-form @submit.stop.prevent="addLayer">
          <b-form-row>
            <b-col cols="12">
              <b-alert variant="danger" :show="showError"><strong>Uwaga.</strong> Formularz zawiera błędy</b-alert>
            </b-col>
          </b-form-row>
          <b-form-row v-if="showError">
            <b-col offset="3" cols="9">
              <small class="text-danger">Należy podać nazwę warstwy</small>
            </b-col>
          </b-form-row>
          <b-form-row>
            <b-col cols="3">
              <label>Nazwa warstwy</label>
            </b-col>
            <b-col cols="9">
              <b-input class="col-md-12" maxlength="66" v-model="layerName" placeholder="Wpisz" :state="validated && layerNameIsEmpty ? false : null"></b-input>
            </b-col>
          </b-form-row>
        </b-form>
    </b-modal>
    <loading-overlay :active="$store.getters.temporaryLayersModuleLoading" :is-full-page="true"></loading-overlay>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import CollapsibleWidget from "./CollapsibleWidget";
import CompositionLayers from "./CompositionLayers";
import LoadingOverlay from 'vue-loading-overlay';
import { TEMPORARY_LAYER_SAVE_NAME } from "../store/actions.type";
import { TEMPORARY_LAYER_MODAL_HIDDEN, USER_LAYERS_EXPANDED_SET, SET_LAYER_VISIBILITY, TEMPORARY_LAYER_SET_VISIBILITY } from '../store/mutations.type';

export default {
  name: "Compositions",
  props: {
    accordion: {
      type: String,
      default: 'panel'
    }
  },
  components: {
    CollapsibleWidget,
    CompositionLayers,
    LoadingOverlay
  },
  data() {
    return {
      validated: false,
      layerName: null
    };
  },
  computed: {
    ...mapGetters(["readOnly"]),
    userGroupLayers() {
      return Array(...this.$store.getters.userGroupLayers.sort((a, b) => { return b.order - a.order; }));
    },
    userLayersHasItems() {
      return this.userGroupLayers.length > 0;
    },
    showModal: {
      get() { return this.$store.getters.temporaryLayerSaveModalVisibility; },
      set(value) { if (!value) this.$store.commit(TEMPORARY_LAYER_MODAL_HIDDEN); }
    },
    layerNameIsEmpty() {
      return !this.layerName;
    },
    showError() {
      return this.validated && this.layerNameIsEmpty;
    },
    indeterminate() {
      return this.userGroupLayers.some(l => l.visible) && this.userGroupLayers.some(l => !l.visible);
    },
    allSelected() {
      return this.userGroupLayers.every(l => l.visible);
    }
  },
  methods: {
    onToggled(expanded) {
      this.$emit("toggled", expanded);
      this.$store.commit(USER_LAYERS_EXPANDED_SET, (expanded || {}).expanded);
    },
    async addLayer() {
      this.validated = true;

      if (!this.layerNameIsEmpty) {
        await this.$store.dispatch(TEMPORARY_LAYER_SAVE_NAME, { name: this.layerName, userEmail: this.contextEmail });
      }
    },
    clear() {
      this.validated = false;
      this.layerName = null;
    },
    onCheckboxChanged(value) {
      if (value) {
        this.userGroupLayers.forEach(layer => {
          if (layer.id) {
            this.$store.commit(SET_LAYER_VISIBILITY, { layerId: layer.id, visible: true });
          } else {
            this.$store.commit(TEMPORARY_LAYER_SET_VISIBILITY, { layer: layer, visible: true });
          }
        });
      } else {
        this.userGroupLayers.forEach(layer => {
          if (layer.id) {
            this.$store.commit(SET_LAYER_VISIBILITY, { layerId: layer.id, visible: false });
          } else {
            this.$store.commit(TEMPORARY_LAYER_SET_VISIBILITY, { layer: layer, visible: false });
          }
        });
      }
    },
    setLayerExtent(extent) {
      this.$emit("set-layer-extent", extent);
    }
  }
};
</script>